/**
 * Canonical metros for the waitlist.
 *
 * The field was free text, lowercased and stored verbatim — so "austin", "atx" and "austin, tx"
 * were three different cities, and a city-by-city rollout cannot segment a list it cannot group.
 * A select fixes that at the source rather than with a cleanup script that has to be re-run.
 *
 * Deliberately a SHORT list plus an escape hatch, not fifty options. A long dropdown of metros that
 * will not open for years reads as vapour, and someone in a metro that is not listed still needs a
 * way to raise their hand — `other` keeps them countable while their typed answer rides along in
 * the submission metadata, which already carries free-form fields.
 *
 * Ordered by launch intent, not alphabetically: the city being recruited for is first.
 *
 * Slugs are the canonical metro vocabulary from kynward-backend src/data/metros.go, so this column
 * joins beta_testers.metro_slug. They used to be city-only ("austin", "nyc") and could not: New York
 * was the worst case, since the app catalog lists Brooklyn and Jersey City separately. The backend
 * still accepts the old slugs and normalizes them, so links already in the wild keep working.
 */
export type WaitlistMetro = { slug: string; label: string };

export const WAITLIST_METROS: readonly WaitlistMetro[] = [
  { slug: 'austin-tx', label: 'Austin, TX' },
  { slug: 'dallas-tx', label: 'Dallas–Fort Worth, TX' },
  { slug: 'houston-tx', label: 'Houston, TX' },
  { slug: 'san-antonio-tx', label: 'San Antonio, TX' },
  { slug: 'denver-co', label: 'Denver, CO' },
  { slug: 'chicago-il', label: 'Chicago, IL' },
  { slug: 'new-york-ny', label: 'New York, NY' },
  { slug: 'los-angeles-ca', label: 'Los Angeles, CA' },
  { slug: 'san-francisco-ca', label: 'San Francisco Bay Area, CA' },
  { slug: 'seattle-wa', label: 'Seattle, WA' },
  { slug: 'portland-or', label: 'Portland, OR' },
  { slug: 'phoenix-az', label: 'Phoenix, AZ' },
  { slug: 'atlanta-ga', label: 'Atlanta, GA' },
  { slug: 'nashville-tn', label: 'Nashville, TN' },
  { slug: 'miami-fl', label: 'Miami, FL' },
  { slug: 'boston-ma', label: 'Boston, MA' },
  { slug: 'philadelphia-pa', label: 'Philadelphia, PA' },
  { slug: 'washington-dc', label: 'Washington, DC' },
  { slug: 'minneapolis-mn', label: 'Minneapolis–St. Paul, MN' },
  { slug: 'other', label: 'Somewhere else' },
];

export const WAITLIST_METRO_OTHER = 'other';
